import { Component, OnInit } from "@angular/core";
import { InstacitiJSON2 } from "../instaciti-new.interface";
import { InstacitiNewService } from "../service/instaciti-new.service";

@Component({
  selector: "portal-instaciti-quick-categories",
  templateUrl: "./instaciti-quick-categories.component.html",
  styleUrls: ["./instaciti-quick-categories.component.css"],
})
export class InstacitiQuickCategoriesComponent implements OnInit {
  json2: InstacitiJSON2[];
  constructor(private service: InstacitiNewService) {}

  ngOnInit(): void {
    this.service.instaSubject.subscribe((res) => {
      if (res) {
        this.json2 = this.service.getGlobalJson2();
      }
    });
  }
}
